import { OpenWorkbookInDesktopDialogContent,OpenWorkbookInDesktopDialogContentProps } from '@tableau/open-workbook-in-desktop-dialog-content';
import { SourceType } from '@tableau/open-workbook-in-desktop-dialog-content/lib/src/telemetry/TelemetryConstants';
import { WorkbookInfo } from '@tableau/open-workbook-in-desktop-dialog-content/lib/src/WorkbookInfo';
import { HostedStackedElementContainer } from '@tableau/widgets';
import React from 'react';
import { call, put, select } from 'redux-saga/effects';

import { WindowLocationService } from '~commonInfra/services/WindowLocationService';
import { SessionServerSelectors,SessionSiteSelectors } from '~selectors/SessionInfoSelectors';
import { getViewDetailInfo } from '~src/spacesPlatform/sagas/content/ContentDetailSagas';
import { IViewDetailInfo } from '~src/ts/models/IViewInfo';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { ContentType, OpenWorkbookInDesktopAction } from '../actions/OpenWorkbookInDesktopAction';
import { fetchWorkbookById } from './WorkbookSagasHelper';

export function* handleOpenWorkbookInDesktop(action: OpenWorkbookInDesktopAction) {
  try {
    let workbookId: string = '';
    let viewLuid: string = '';
    switch(action.item.contentType) {
      case ContentType.Workbook:
        workbookId = action.item.id;
        break;
      case ContentType.View:
        const viewDetailInfo: IViewDetailInfo = yield call(getViewDetailInfo, action.item);
        workbookId = viewDetailInfo.workbook.id;
        viewLuid = viewDetailInfo.luid;
        break;
      default:
        throw new Error(Messages.errorInvalidContentType());
    }
    const workbookInfo = yield call(fetchWorkbookById, workbookId);
    const siteLuid: string = yield select(SessionSiteSelectors.siteLuid);
    const isOnlineEnvironment: boolean = yield select(SessionServerSelectors.isOnlineEnvironment);

    yield call(() => OpenWorkbookInDesktopDialog.renderDialog(workbookInfo.luid, viewLuid, workbookInfo.size, siteLuid, isOnlineEnvironment));
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnableToLaunchOpenInDesktopDialog()));
  }
}

export namespace OpenWorkbookInDesktopDialog {
  export async function renderDialog(workbookLuid: string, viewLuid: string, workbookSize: number, siteLuid: string, isOnlineEnvironment: boolean): Promise<boolean> {
    return new Promise((resolve, reject) => {
      var workbookInfo: WorkbookInfo = {
        serverHost: WindowLocationService.getOrigin(),
        siteLuid: siteLuid,
        workbookLuid: workbookLuid,
        size: workbookSize,
        viewLuid: viewLuid
      };

      const dialogProps: OpenWorkbookInDesktopDialogContentProps = {
        isTableauOnline: isOnlineEnvironment,
        primaryActionButtonLabel: Messages.openWorkbookInDesktopPrimaryActionLabel(),
        workbookInfo: workbookInfo,
        source: viewLuid ? SourceType.VizPortalClientView : SourceType.VizPortalClientWorkbook
      };

      const dialog = React.createElement(OpenWorkbookInDesktopDialogContent, dialogProps);
      const hostContainer = new HostedStackedElementContainer();
      hostContainer.render(dialog);
    });
  }
}
